import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import theme from "./assets/styles/theme";
import { ThemeProvider, CssBaseline } from "@mui/material"; // ← include CssBaseline
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* CssBaseline safely normalizes styles and ensures theme loads correctly */}
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
